<div class="card">
    <div class="row">
        <div class="col-lg-12">
            <div class="card border-0 shadow-none">
                <div class="card-body">
                    <div class="row d-flex">
                        <div class="col-sm-4">
                            <label class="col-form-label" for="settlementCycle">Settlement Cycle<span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                             <!-- [readonly]="settlementEnable" -->
                            <ng-select [items]="settlementCycleList"
                                [style]="settlementEnable ? { 'background-color': '#e9ecef' } : {}" bindLabel="name"
                                bindValue="value" [(ngModel)]="settlementCycle" id="settlementCycle"
                                placeholder="Select Settlement Cycle">
                            </ng-select>
                        </div>
                        <div class="col-sm-6" style="margin-top:35px">
                            <button class="btn btn-primary" type="button"
                                *ngIf="!dataEnable && permissions.includes('Add')"
                                (click)="editSettlement(!settlementEnable)">{{settlementEnable ?
                                'Edit':'Cancel'}}</button>
                        </div>
                    </div>
                    <hr>
                    <div class="row mt-4">
                        <div class="col-sm-6">
                            <label class="col-form-label" for="settlementCycle">Merchant Fee<span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                        </div>
                        <div class="col-sm-6 text-right mb-2" *ngIf="permissions.includes('Add')">
                            <button class="btn btn-primary" *ngIf="!(commissionList.length==0) && !dataEnable"
                                type="button" (click)="editCommission(!commissionEnable)">{{commissionEnable ?
                                'Edit':'Cancel'}}</button>
                            <button class="btn btn-primary mr-2" *ngIf="!(commissionList.length==0)" type="button"
                                (click)="resetCommissionTable()">Reset</button>
                            <button class="btn btn-primary" *ngIf="(commissionList.length==0)" style="width: 25%;"
                                type="button" (click)="setCommission()">Set Commission</button>
                        </div>
                    </div>

                    <!-- Max Value Control for Commission -->
                    <div class="row mt-2" *ngIf="!(commissionList.length==0) && permissions.includes('Add')">
                        <div class="col-sm-4">
                            <label class="col-form-label">Max Commission Amount:</label>
                            <div class="input-group">
                                <input type="number" class="form-control"
                                    [value]="editingCommissionMaxValue ? tempCommissionMaxValue : maximumCommissionAmount"
                                    (input)="onCommissionMaxValueChange($event)" [readonly]="!editingCommissionMaxValue"
                                    [style]="!editingCommissionMaxValue ? { 'background-color': '#e9ecef' } : {}">
                                <div class="input-group-append">
                                    <button class="btn btn-primary" type="button" *ngIf="!editingCommissionMaxValue"
                                        (click)="editCommissionMaxValue()">Edit</button>
                                    <button class="btn btn-success" type="button" *ngIf="editingCommissionMaxValue"
                                        (click)="applyCommissionMaxValue()">Apply</button>
                                    <button class="btn btn-secondary" type="button" *ngIf="editingCommissionMaxValue"
                                        (click)="cancelCommissionMaxValue()">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="min-height: 300px" *ngIf="!(commissionList.length==0)">
                        <div class="col-12 col-xl-12 stretch-card ag-theme-alpine">
                            <ag-grid-angular [columnDefs]="columnCommission" [defaultColDef]="defaultColDef"
                                [rowData]="commissionList"
                                [ngClass]="{ 'disabled-grid': commissionEnable && !dataEnable  }"
                                [paginationPageSize]="pageSize" [pagination]="true" [suppressPaginationPanel]="true"
                                (gridReady)="onGridReadyCommission($event)" [rowSelection]="'single'"
                                class="ag-theme-alpine" style="width: 100%; height: auto;">
                            </ag-grid-angular>
                        </div>
                    </div>
                    <hr>
                    <div class="row mt-4">
                        <div class="col-sm-6">
                            <label class="col-form-label" for="settlementCycle">Additional Fee<span aria-hidden="true"
                                    class="symbol required" style="color:red;">*</span>
                            </label>
                        </div>
                        <div class="col-sm-6 text-right mb-2" *ngIf="permissions.includes('Add')">
                            <button class="btn btn-primary" *ngIf="!(feeList.length==0) && !dataEnable" type="button"
                                (click)="editFee(!feeEnable)">{{feeEnable ? 'Edit':'Cancel'}}</button>
                            <button class="btn btn-primary mr-2" *ngIf="!(feeList.length==0)" type="button"
                                (click)="resetFeeTable()">Reset</button>
                            <button class="btn btn-primary" *ngIf="!(feeList.length==0)" style="width: 15%;"
                                type="button" (click)="addFeeRow()">Add</button>
                            <button class="btn btn-primary" *ngIf="(feeList.length==0)" style="width: 25%;"
                                type="button" (click)="setFee()">Set Fee</button>
                        </div>
                    </div>

                    <!-- Max Value Control for Fee -->
                    <div class="row mt-2" *ngIf="!(feeList.length==0) && permissions.includes('Add')">
                        <div class="col-sm-4">
                            <label class="col-form-label">Max Additional Fee Amount:</label>
                            <div class="input-group">
                                <input type="number" class="form-control"
                                    [value]="editingFeeMaxValue ? tempFeeMaxValue : maximumFeeAmount"
                                    (input)="onFeeMaxValueChange($event)" [readonly]="!editingFeeMaxValue"
                                    [style]="!editingFeeMaxValue ? { 'background-color': '#e9ecef' } : {}">
                                <div class="input-group-append">
                                    <button class="btn btn-primary" type="button" *ngIf="!editingFeeMaxValue"
                                        (click)="editFeeMaxValue()">Edit</button>
                                    <button class="btn btn-success" type="button" *ngIf="editingFeeMaxValue"
                                        (click)="applyFeeMaxValue()">Apply</button>
                                    <button class="btn btn-secondary" type="button" *ngIf="editingFeeMaxValue"
                                        (click)="cancelFeeMaxValue()">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="min-height: 300px" *ngIf="!(feeList.length==0)">
                        <div class="col-12 col-xl-12 stretch-card ag-theme-alpine">
                            <ag-grid-angular [columnDefs]="columnFee" [defaultColDef]="defaultColDef"
                                [rowData]="feeList" [ngClass]="{ 'disabled-grid': feeEnable && !dataEnable }"
                                [paginationPageSize]="pageSize" [pagination]="true" [suppressPaginationPanel]="true"
                                (gridReady)="onGridReadyFee($event)" [rowSelection]="'single'" class="ag-theme-alpine"
                                style="width: 100%; height: auto;">
                            </ag-grid-angular>
                        </div>
                    </div>
                    <div *ngIf="showResellerCommissionSection">

                        <hr />
                        <!-- Header -->
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <label class="mb-0 font-weight-bold">
                                Partner Commission <span class="text-danger">*</span>
                            </label>
                            <!-- <div class="row mb-2" *ngIf="permissions.includes('Add')"> -->
                            <div class="row mb-2">
                                <div class="col text-right">
                                    <!-- <button class="btn btn-yellow px-4" type="button" *ngIf="commissionEnable" (click)="editCommission(false)">
                                        Edit
                                    </button> -->
                                    <button class="btn btn-primary" type="button"
                                        (click)="editResellerCommission(!resellerCommissionEnable)">{{resellerCommissionEnable
                                        ?
                                        'Edit':'Cancel'}}</button>
                                </div>
                            </div>
                        </div>

                        <!-- Column Labels -->
                        <div class="row text-muted small mb-1">
                            <div class="col">Partner Name</div>
                            <!-- <div class="col text-center">Special Partner</div> -->
                            <div class="col">Commission Model</div>
                            <div class="col">Commission %</div>
                            <div class="col">Effective Date</div>
                        </div>

                        <!-- Inputs -->
                        <div class="row align-items-center">

                            <!-- Partner Name -->
                            <div class="col">
                                <input type="text" class="form-control" [(ngModel)]="resellerName"
                                    placeholder="Enter Partner Name" disabled=true
                                    (keypress)="allowOnlyLetters($event)" />
                            </div>

                            <!-- Special Partner not required as of now-->
                            <!-- <div class="col-md-1 text-center special-partner-col">
                                <input type="checkbox" class="special-partner-checkbox" [(ngModel)]="isSpecialPartner"
                                    disabled=true />
                            </div> -->

                            <!-- Commission Model -->
                            <div class="col">
                                <input type="text" class="form-control" [(ngModel)]="commissionModel"
                                 (keypress)="allowOnlyLetters($event)"
                                    disabled=true />
                            </div>

                            <!-- Commission % -->
                            <div class="col position-relative commission-percent-wrapper">
                                <input type="text" class="form-control" [(ngModel)]="commissionPercentage"
                                    placeholder="Enter Commission %" (keypress)="allowOnlyNumbersAndDot($event)"
                                    [disabled]=" resellerCommissionEnable || commissionModel === 'Fixed'" />

                                <!-- Hover Min–Max -->
                                <div class="min-max-hover-box" *ngIf="constantList && commissionModel === 'Fixed'">
                                    <div class="min-max-title">Min–Max</div>
                                    <div class="min-max-value">
                                        {{ constantList.fromAmount }} – {{ constantList.toAmount }}%
                                    </div>
                                </div>
                            </div>

                            <!-- Effective Date -->
                            <div class="col">
                                <input type="date" class="form-control" [(ngModel)]="effectiveDate" [min]="today"
                                    disabled=true />
                            </div>

                        </div>

                    </div>

                    <div class="row mt-4"
                        *ngIf="!(feeList.length==0) && !(commissionList.length==0) && settlementCycle != null">
                        <div class="form-group col-md-12 text-right mr-4">
                            <button class="btn btn-primary" style="width: 15%;" type="button"
                                (click)="saveCommission(dataEnable ? 'Save' : 'Update')">{{dataEnable ? 'Save' :
                                'Update'}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>